// src/components/MessageInput.js
import React, { useState } from 'react';

// isLoading viene passato da App.js
// App.js decide quando MessageInput deve essere "loading"
// (es. quando readyState !== ReadyState.OPEN o quando messages.some(msg => msg.isLoading))
function MessageInput({ onSendMessage, isLoading, inputRef }) {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!inputValue.trim() || isLoading) return;
    onSendMessage(inputValue);
    setInputValue('');
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  return (
    <form className="message-input-form" onSubmit={handleSubmit}>
      <input
        ref={inputRef}
        type="text"
        className="message-input"
        value={inputValue}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder="Scrivi il tuo messaggio..."
        disabled={isLoading} // Disabilitato se isLoading è true
        aria-busy={isLoading}
      />
      <button
        type="submit"
        className="send-button"
        disabled={isLoading || !inputValue.trim()} // Disabilitato se isLoading è true o input vuoto
        aria-label={isLoading ? "Invio in corso o non disponibile" : "Invia messaggio"}
      >
        {isLoading ? (
          <span className="spinner" aria-hidden="true"></span>
        ) : (
          // NUOVA ICONA PER L'INVIO
          <img
            src="/send_arrow_icon.svg" // Percorso all'icona SVG (deve essere nella cartella public)
            alt="Invia"
            style={{ width: '24px', height: '24px', display: 'block', filter: 'invert(1)' }}
            // 'filter: invert(1)' è utile se l'SVG è nero e il bottone è scuro, per renderlo bianco
          />
        )}
      </button>
    </form>
  );
}

export default MessageInput;